import { Component, Input, OnInit } from '@angular/core';
import { AdministrativeService } from 'src/app/services/administrative/administrative.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-clients-informations',
  templateUrl: './clients-informations.component.html',
  styleUrls: ['./clients-informations.component.scss']
})
export class ClientsInformationsComponent implements OnInit {
  @Input() clientId!: number;
  pdvs: any[] = [];
  loading = false;

  constructor(
    private adminService: AdministrativeService,
    private route: ActivatedRoute
  ) {}

  async ngOnInit() {
    const paramId = this.route.snapshot.queryParamMap.get('clientId');
    if (!this.clientId && paramId) {
      this.clientId = Number(paramId);
    }

    if (!this.clientId) {
      return;
    }

    this.loading = true;
    try {
      const apiData = await this.adminService.getPdvsInformationsByCompanyId(this.clientId);
      const pdvsMap = new Map();
      
      (apiData ?? []).forEach(item => {
        const pdvKey = item.pdvDescription || `PDV ${item.pdvId}`;
        
        if (!pdvsMap.has(pdvKey)) {
          pdvsMap.set(pdvKey, {
            pdvId: item.pdvId,
            pdvDescription: item.pdvDescription?.toUpperCase() || `PDV ${item.pdvId}`,
            tags: []
          });
        }

        pdvsMap.get(pdvKey).tags.push({
          name: item.tagName,
          value: item.value
        });
      });

      this.pdvs = Array.from(pdvsMap.values()).sort();      
    } catch (err) {
    }
    this.loading = false;
  }
}